import { useTranslation } from "react-i18next";
import { IconType } from "react-icons";
import { FaFileContract, FaInfo, FaShieldAlt, FaShoppingCart } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { useSub } from "../../../common/subscription/useSub";
import { useOrganizationProfileUrls } from "../useOrganizationProfileUrls";

export interface OrgProfileMenuItem {
  section: string;
  label: string;
  icon: IconType;
  to: string;
}

export const useOrgProfileMenuItems = (): OrgProfileMenuItem[] => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { hasOrganizationAssessmentAccess } = useSub();
  const profileUrls = useOrganizationProfileUrls();

  return [
    {
      section: profileUrls.sections.information,
      label: t("Details"),
      icon: FaInfo,
      to: profileUrls.section(profileUrls.sections.information, searchParams),
    },
    {
      section: profileUrls.sections.contracts,
      label: t("Contracts"),
      icon: FaFileContract,
      to: profileUrls.section(profileUrls.sections.contracts, searchParams),
    },
    {
      section: profileUrls.sections.sourcingEvents,
      label: t("Sourcing Events"),
      icon: FaShoppingCart,
      to: profileUrls.section(profileUrls.sections.sourcingEvents, searchParams),
    },
    ...(hasOrganizationAssessmentAccess
      ? [
          {
            section: profileUrls.sections.reviewsRisk,
            label: t("Reviews & Risk"),
            icon: FaShieldAlt,
            to: profileUrls.section(profileUrls.sections.reviewsRisk, searchParams),
          },
        ]
      : []),
  ];
};
